import { useState } from "react";
import { RefreshCw } from "lucide-react";
import { colors, fonts } from "../../styles/theme";
import { triggerRescore } from "../../services/api";
import { TIER_COLORS } from "./constants";

export default function EngagementScoreBadge({ contact }) {
  const [rescoring, setRescoring] = useState(false);
  const [score, setScore] = useState(contact.engagementScore);
  const [tier, setTier] = useState(contact.engagementTier);

  const tc = TIER_COLORS[tier] || TIER_COLORS.cold;

  const handleRescore = async () => {
    setRescoring(true);
    try {
      const result = await triggerRescore(contact.id);
      if (result.contact) {
        setScore(result.contact.score);
        setTier(result.contact.tier);
      }
    } catch {
      // silently fail
    } finally {
      setRescoring(false);
    }
  };

  if (score == null) {
    return (
      <div style={{ marginBottom: 16 }}>
        <button
          onClick={handleRescore}
          disabled={rescoring}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            padding: "6px 12px",
            background: colors.bg,
            border: `1px solid ${colors.border}`,
            borderRadius: 6,
            fontSize: 12,
            fontFamily: fonts.body,
            color: colors.textSecondary,
            cursor: rescoring ? "wait" : "pointer",
          }}
        >
          <RefreshCw
            size={12}
            className={rescoring ? "spin" : undefined}
          />
          {rescoring ? "Scoring..." : "Calculate Score"}
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 12,
        padding: "10px 14px",
        background: tc.bg,
        border: `1px solid ${tc.color}33`,
        borderRadius: 8,
        marginBottom: 16,
      }}
    >
      <div
        style={{
          fontSize: 28,
          fontWeight: 700,
          fontFamily: fonts.mono,
          color: tc.color,
          lineHeight: 1,
        }}
      >
        {score}
      </div>
      <div style={{ flex: 1 }}>
        <div style={{ fontSize: 13, fontWeight: 700, color: tc.color }}>
          {tc.label}
        </div>
        <div style={{ fontSize: 10, color: colors.textSecondary }}>
          Engagement Score
        </div>
      </div>
      <button
        onClick={handleRescore}
        disabled={rescoring}
        title="Recalculate score"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 24,
          height: 24,
          borderRadius: 4,
          border: "none",
          background: "transparent",
          cursor: rescoring ? "wait" : "pointer",
          opacity: 0.5,
          transition: "opacity 0.15s",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
        onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.5")}
      >
        <RefreshCw
          size={12}
          color={tc.color}
          className={rescoring ? "spin" : undefined}
        />
      </button>
    </div>
  );
}
